import { initializeOtelLogging } from '@glomopay/telemetry';

import { SERVICE_NAME } from '@/constants/telemetry';
import { enrichmentContext } from '@/lib/telemetry/enrichment-context';

export function initializeOpenTelemetry() {
  initializeOtelLogging({
    serviceName: SERVICE_NAME,
    environment: import.meta.env.MODE,
    logExporterUrl: `${import.meta.env.VITE_OTEL_SIGNALS_BASE_URL}/v1/logs`,
    attributeSource: enrichmentContext,
  });
}
